/* eslint consistent-return:0 */

const isEmpty = value => value === undefined || value === null || value === '';
const join = rules => (value, data) => rules.map(rule => rule(value, data)).filter(error => !!error)[0];

export function email(value) {
  // Let's not start a debate on email regex. This is just for an example app!
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return 'Invalid email address';
  }
}

export function required(value) {
  if (isEmpty(value)) {
    return 'Required';
  }
}

export function minLength(min) {
  return (value) => {
    if (!isEmpty(value) && value.length < min) {
      return `Must be at least ${min} characters`;
    }
  };
}

export function maxLength(max) {
  return (value) => {
    if (!isEmpty(value) && value.length > max) {
      return `Must be no more than ${max} characters`;
    }
  };
}

export function integer(value) {
  if (!Number.isInteger(Number(value))) {
    return 'Must be an integer';
  }
}

export function postalCode(value) {
  if (!value.match(/\d{5}([ \-]\d{4})?/)) { // eslint-disable-line no-useless-escape
    return 'Must be a valid zip code';
  }
}

export function oneOf(enumeration) {
  return (value) => {
    if (!~enumeration.indexOf(value)) { // eslint-disable-line no-bitwise
      return `Must be one of: ${enumeration.join(', ')}`;
    }
  };
}

export function match(field) {
  return (value, data) => {
    if (data) {
      if (value !== data[field]) {
        return 'Do not match';
      }
    }
  };
}

export function googleAnalyticsId(value) {
  if (value && !/^UA-[a-zA-Z0-9-]+$/.test(value)) {
    return 'ID must be in the form of UA-XXXXXX';
  }
}

export function googleTagManagerId(value) {
  if (value && !/^GTM-[a-zA-Z0-9]+$/.test(value)) {
    return 'ID must be in the form of GTM-XXXXXX';
  }
}

export function facebookPixelId(value) {
  if (value && !/^[0-9]*$/.test(value)) {
    return 'ID can only contain numbers';
  }
}

export function url(value) {
  if (value && !/^http:\/\/|^https:\/\//.test(value)) {
    return 'Please include the protocol (http:// or https://) with the url.';
  }
}

export function createValidator(rules) {
  return (data = {}) => {
    const errors = {};
    Object.keys(rules).forEach((key) => {
      const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      const error = rule(data[key], data);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}
